import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function FirearmCaliberRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/firearm-caliber', component: Index, isProtected: true, permissions: ['firearm_caliber_index']},
    {path: '/firearm-caliber/create', component: Create, isProtected: true, permissions: ['firearm_caliber_create']},
    {path: '/firearm-caliber/edit/:id', component: Edit, isProtected: true, permissions: ['firearm_caliber_edit']},

  ];

  return routes;
}
